import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import { FaAngleLeft } from "react-icons/fa6";
import { SlHome } from "react-icons/sl";
import { IoShareSocialOutline } from "react-icons/io5";
import { useDispatch, useSelector } from "react-redux";
import { addCart, removeCart, removeAllItems } from "../Redux/Cart_System";
import {
  addFavorite,
  addRemoveFavorite,
  getFavorite,
  ResturentSlug,
  ResturentSlugItem,
} from "../Services/Operations/ProductAPI";
import { FaAngleDown } from "react-icons/fa6";
import { FaAngleUp } from "react-icons/fa6";
import { FaRegHeart, FaHeart } from "react-icons/fa";

const PageDetails = () => {
  const token = useSelector((state) => state.user.token);
  const itemCart = useSelector((state) => state.cart.items);
  const navigation = useNavigate();
  const [Slug, setSlug] = useState([]);
  const [recommended, setRecommended] = useState([]);
  const [isFavorite, setIsFavorite] = useState(false);
  const [items, setItems] = useState([]);
  const dispatch = useDispatch();
  const BASE_URL = "https://zotpot.in";

  const location = useLocation();
  const { longitude, latitude, store } = location.state || {};

  console.log("item cart : ", itemCart);

  const cartItems = useSelector((state) => state.cart.items);
  const [showPopup, setShowPopup] = useState(false);
  const [favorite, setFavorite] = useState([]);

  const handleAddToCart = (product, store) => {
    if (cartItems.length > 0 && cartItems[0].store.name !== store.name) {
      setShowPopup(true);
    } else {
      dispatch(addCart({ product, store }));
    }
  };

  const handlePopupConfirm = (product, store) => {
    console.log("product in pageDetails : ", product);
    console.log("Store in pageDetails : ", store);
    dispatch(removeAllItems());
    dispatch(addCart({ product, store }));
    setShowPopup(false);
    navigation("/");
  };

  const handlePopupCancel = () => {
    setShowPopup(false);
  };

  const handleFavorite = async (Store) => {
    try {
      const formData = new FormData();
      formData.append("token", token);
      formData.append("id", Store.id);

      if (!isFavorite) {
        const response = await addRemoveFavorite(formData);
        if (response) {
          setIsFavorite(true);
          console.log("Added to Favorite:", response.data);
        }
      } else {
        const response = await addRemoveFavorite(formData);
        if (response) {
          setIsFavorite(false);
          console.log("Removed from Favorite:", response.data);
        }
      }
    } catch (error) {
      console.error("Error updating favorite status:", error);
    }
  };

  useEffect(() => {
    const fetchResturent = async () => {
      try {
        //console.log("slug : ", store.slug)
        const response = await ResturentSlug(store.slug);
        const response1 = await ResturentSlugItem(store.slug);

        console.log("response : ", response);
        console.log("response1 : ", response1);

        const formData = new FormData();
        formData.append("token", token);
        formData.append("latitude", latitude);
        formData.append("longitude", longitude);
        for (let pair of formData.entries()) {
          console.log(`${pair[0]}: ${pair[1]}`);
        }

        const response2 = await getFavorite(formData);
        if (response2) {
          console.log("Favorite Data:", response2);
          setFavorite(response2);
        }
        setSlug(response);
        setRecommended(response1.recommended);
        setItems(response1.items);
        console.log("item : ", response1);
      } catch (error) {
        console.error("Error fetching restaurant details:", error);
      }
    };
    fetchResturent();
  }, []);

  const handleStoreClick = (id, Slug) => {
    if (id && Slug) {
      //console.log("ahfjagfui")
      //console.log("ID: ", id);
      //console.log("Slug: ", Slug);
      navigation("/product-details", { state: { id, Slug } });
    } else {
      console.warn("Invalid data passed to handleStoreClick", { id, Slug });
    }
  };

  // const handleAddToCart = (product, store) => {
  //   dispatch(addCart({ product, store }));
  // };

  const handleRemoveFromCart = (id, store) => {
    dispatch(removeCart({ id, store }));
  };

  const [openCategories, setOpenCategories] = useState({});

  const handleToggleCategory = (categoryName) => {
    setOpenCategories((prev) => ({
      ...prev,
      [categoryName]: !prev[categoryName],
    }));
  };

  if (!store) {
    return <div>No Store Data Available</div>;
  }

  //console.log("openCategories : ",openCategories)

  const favoriteItem = favorite.find((item) => item.id === Slug.id);

  return (
    <div
      style={{
        padding: "20px",
        backgroundColor: "#f9f9f9",
        filter: Slug.is_active !== 1 ? "grayscale(100%)" : "none",
      }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          marginBottom: "23px",
        }}
      >
        <FaAngleLeft onClick={() => navigation(-1)} />
        <div style={{ display: "flex", gap: "20px" }}>
          <Link to="/">
            <SlHome />
          </Link>
          <IoShareSocialOutline />
        </div>
      </div>
      <div style={{ height: "109px",filter: Slug.is_active !== 1 ? "grayscale(100%)" : "none",pointerEvents: Slug.is_active !== 1 ? "none" : "auto",}} className="store-item" key={Slug.id}>
        <img
          style={{
            width: "111px",
          }}
          src={`${BASE_URL}${Slug.image}`}
          alt={Slug.name}
        />
        <div
          style={{
            marginLeft: "20px",
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            alignItems: "flex-start",
            position: "relative",
            width: "51%",
          }}
        >
          <h3 style={{ margin: "0px", textAlign: "left", width: "86%" }}>
            {Slug.name}
          </h3>
          <p style={{ margin: "0px", textAlign: "left" }}>{Slug.description}</p>
          <div
            onClick={() => handleFavorite(Slug)}
            style={{
              position: "absolute",
              top: "0px",
              left: "140px",
              fontSize: "22px",
              // backgroundColor: isFavorite ? "red" : "transparent",
              borderRadius: "50%",
              padding: "5px",
              cursor: "pointer",
            }}
          >
            {favoriteItem || isFavorite ? (
              <FaHeart style={{ color: "red" }} />
            ) : (
              <FaRegHeart />
            )}
          </div>
          <div className="store-details">
            <span>{Slug.rating}</span>
            <span>{Slug.delivery_time} min</span>
            <span>{Slug.price_range}rs</span>
          </div>
        </div>
      </div>
      <div className="store-list" style={{pointerEvents: Slug.is_active !== 1 ? "none" : "auto",}}>
        <div className="search" style={{ marginTop: "30px" }}>
          <input
            style={{ margin: "0 auto", width: "85%" }}
            className="input"
            type="text"
            placeholder="Search for stores or items..."
          />
        </div>
      </div>
      <div style={{pointerEvents: Slug.is_active !== 1 ? "none" : "auto",}}>
        <h4
          style={{
            marginTop: "25px",
            marginBottom: "15px",
            fontWeight: "bold",
          }}
        >
          RECOMMENDED
        </h4>
        <div
          style={{
            display: "flex",
            gap: "20px",
            width: "100%",
            margin: "0px",
            overflowX: "auto",
            scrollbarWidth: "none",
          }}
          id="product-list"
        >
          {recommended.map((product) => {
            const cartItem = itemCart.find(
              (item) => item.product.id === product.id
            );

            return (
              <div
                key={product.id}
                style={{
                  height: "222px",
                  width: "197px",
                  flexShrink: 0,
                }}
              >
                <div
                  style={{
                    boxShadow:
                      "rgba(50, 50, 93, 0.25) 0px 13px 27px -5px, rgba(0, 0, 0, 0.3) 0px 8px 16px -8px",
                    borderRadius: "10px",
                    height: "100%",
                  }}
                >
                  <figure
                    style={{ height: "50%", margin: 0 }}
                    onClick={() => handleStoreClick(product.id, Slug)}
                  >
                    <div
                      style={{
                        height: "100%",
                        display: "block",
                        position: "relative",
                        overflow: "hidden",
                      }}
                    >
                      <img
                        src={`${BASE_URL}${product.image}`}
                        alt={product.title}
                        style={{
                          width: "100%",
                          objectFit: "cover",
                          height: "100%",
                          borderTopLeftRadius: "10px",
                          borderTopRightRadius: "10px",
                          transition: "0.5s",
                          backgroundColor:
                            Slug.is_active === 1 ? "transparent" : "black",
                          filter:
                            Slug.is_active !== 1 ? "grayscale(100%)" : "none",
                        }}
                      />
                      {cartItem && (
                        <div className="number">
                          {cartItem.product.quantity}
                        </div>
                      )}
                    </div>
                  </figure>
                  <div style={{ textAlign: "center", padding: "10px" }}>
                    <h6 style={{ margin: "5px 0" }}>{product.name}</h6>
                    <p style={{ margin: "5px 0" }}>{product.price}</p>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      gap: "15px",
                      paddingBottom: "10px",
                    }}
                  >
                    <button
                      onClick={() => handleRemoveFromCart(product.id, store)}
                      style={{ width: "40%", padding: "5px" }}
                    >
                      -
                    </button>
                    <button
                      onClick={() => handleAddToCart(product, store)}
                      style={{ width: "40%", padding: "5px" }}
                    >
                      +
                    </button>
                  </div>
                </div>

                {showPopup && (
                  <div
                    className={`popup-overlay1 ${showPopup ? "active" : ""}`}
                  >
                    <div className="popup">
                      <h4 style={{ fontSize: "21px", margin: "10px" }}>
                        Replace items already in the cart?
                      </h4>
                      <p style={{ marginBottom: "17px" }}>
                        Your cart contains items from another store. Do you want
                        to discard the selection and add items from this store?
                      </p>
                      <div style={{ display: "flex", gap: "17px" }}>
                        <button onClick={handlePopupCancel}>No</button>
                        <button
                          onClick={() => handlePopupConfirm(product, store)}
                        >
                          Yes
                        </button>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
      {Object.keys(items).map((categoryName) => (
        <div key={categoryName} style={{pointerEvents: Slug.is_active !== 1 ? "none" : "auto",}}>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              width: "96%",
              margin: "auto",
            }}
            onClick={() => handleToggleCategory(categoryName)}
          >
            <h5>{categoryName}</h5>
            {openCategories[categoryName] ? <FaAngleUp /> : <FaAngleDown />}
          </div>

          {openCategories[categoryName] && (
            <div className="stores-grid">
              {items[categoryName].map((item) => {
                const cartItem = itemCart.find(
                  (cart) => cart.product.id === item.id
                );

                return (
                  <div
                    style={{
                      height: "75px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                    }}
                    className="store-item"
                    key={item.id}
                  >
                    <div
                      style={{
                        display: "flex",
                        height: "100%",
                        overflow: "hidden",
                        position: "relative",
                      }}
                      onClick={() => handleStoreClick(item.id, Slug)}
                    >
                      <img
                        style={{
                          width: "83px",
                          height: "100%",
                          backgroundColor:
                            Slug.is_active === 1 ? "transparent" : "black",
                          filter:
                            Slug.is_active !== 1 ? "grayscale(100%)" : "none",
                        }}
                        src={`${BASE_URL}${item.image}`}
                        alt={item.name}
                      />

                      {cartItem && (
                        <div className="number">
                          {cartItem.product.quantity}
                        </div>
                      )}

                      <div
                        style={{
                          marginLeft: "10px",
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "normal",
                          alignItems: "flex-start",
                          height: "100%",
                        }}
                      >
                        <p style={{ margin: "0px" }}>{item.name}</p>

                        <div
                          style={{
                            display: "flex",
                            gap: "10px",
                            marginTop: "7px",
                          }}
                        >
                          <button
                            style={{
                              backgroundColor: "#fb2c2cfa",
                              color: "white",
                              borderRadius: "5px",
                              border: "none",
                              padding: "3px 5px",
                            }}
                          >
                            Recommended
                          </button>
                          <button
                            style={{
                              backgroundColor: "orangered",
                              color: "white",
                              borderRadius: "5px",
                              border: "none",
                              padding: "3px 5px",
                            }}
                          >
                            Popular
                          </button>
                        </div>

                        <p style={{ marginTop: "7px" }}>{item.price}</p>
                      </div>
                    </div>

                    <div style={{ display: "flex", gap: "2px" }}>
                      <button
                        onClick={() => handleRemoveFromCart(item, store)}
                        style={{ padding: "3px 15px" }}
                      >
                        -
                      </button>
                      <button
                        onClick={() => handleAddToCart(item, store)}
                        style={{ padding: "3px 15px" }}
                      >
                        +
                      </button>
                    </div>
                  </div>
                );
              })}
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default PageDetails;
